import {Injectable} from '@angular/core';
import {AvailableLangs, TranslocoService} from "@ngneat/transloco";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LangsListParamsService {

  availableLangs$: BehaviorSubject<AvailableLangs> = new BehaviorSubject<AvailableLangs>([]);
  waitingForAvailableLang$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // langChoosedIsDisplayed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  shouldAskLang = false;
  askLang$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  langWasAsked = false;

  allAvailableLangs = [
    {
      id: 'en',
      label: 'English'
    },
    {
      id: 'fr',
      label: 'Français'
    },
    {
      id: 'nl',
      label: 'Nederlands'
    },
    {
      id: 'it',
      label: 'Italian'
    }
  ]

  allAvailableLangsById = {};

  constructor(
    private translocoService: TranslocoService,
  ) {

    // console.log('[LangsListParamsService] constructor');
    this.translocoService.setFallbackLangForMissingTranslation({ fallbackLang: 'fr' });

    // this.translocoService.events$
    //   .subscribe((event) => {
    //     // console.log('[LangsListParamsService] event', event);
    //     if (event.type === 'translationLoadSuccess') {
    // setTimeout(() => {
    this.availableLangs$ = new BehaviorSubject<AvailableLangs>(this.translocoService.getAvailableLangs());
    // console.log('[LangsListParamsService] - this.availableLangs$.value', this.availableLangs$.value);
    this.allAvailableLangs.forEach((aLang) => {
      this.allAvailableLangsById[aLang.id] = aLang;
    })
    this.waitingForAvailableLang$.next(false);
    // }, 500);
    //   }
    //   // console.log(event);
    // });


  }

  setShouldAskLang(state: boolean) {
    this.shouldAskLang = state;
  }

  askLang(force = false) {
    if (force) {
      this.shouldAskLang = true;
      this.langWasAsked = false;
    }
    // Si on a plus d'une langue
    if (this.availableLangs$.value.length > 1) {
      // que la route nous a demandé de le faire
      if (this.shouldAskLang) {
        // que la langue n'a pas été déjà demandée
        if (!this.langWasAsked) {
          // On propage l'info
          this.askLang$.next(true);
        }
      }
    }
  }

  setLangFromAsk(lang: string) {
    this.langWasAsked = true;
    this.askLang$.next(false);
    this.translocoService.setActiveLang(lang);
  }

  updateLangsList(langs: string[]) {
    if (langs.length > 0) {

      const finalLangsAndLabel: any[] = [];

      langs.forEach((aLang) => {
        // console.log(aLang);
        finalLangsAndLabel.push(this.allAvailableLangsById[aLang]);
      })

      // console.log('[LangsListParamsService] - updateLangsList - finalLangsAndLabel', finalLangsAndLabel);
      this.translocoService.setAvailableLangs(finalLangsAndLabel);
      this.availableLangs$.next(this.translocoService.getAvailableLangs());

      if (langs.length === 1) {
        this.translocoService.setActiveLang(langs[0]);
      }

      if (!langs.includes(this.translocoService.getActiveLang())) {
        this.translocoService.setActiveLang(langs[0]);
      }

    }

  }

}
